<div>
  <div class="menuHeading">
    <div class="menuText">My Views</div>
    <img   alt="Create" 
    src="assets/Inbox/createIcon.svg" (click)="addSelected($event)" class="createIcon"
    [ngClass]="{'megamenuCreate':fromMegaMenu}">
  </div>
  <div oncontextmenu="return false;" class="childWrapper" [class.childWrapperShowMore]="fromMegaMenu">
    <div
      *ngFor="let item of (showMore ? filteredItems : filteredItems | slice:0:3)"
    >
      <div
        [ngClass]="{'active-menu': currentActiveTab?.header === item.label, 'menuChild': activeTab?.header !== item.label}"
      >
        <div class="textlink">
          <div
            class="menuChildText item-open current-tab"
            id="{{item.name}}"
            (click)="itemSelected($event)"
          
          >
            {{item.label}}
          </div>
          

        </div>
        <div class="iconButtonsWrap" *ngIf="!fromMegaMenu">
          <img  alt="Open" 
          src="assets/Inbox/openInNewTab.svg"  class="hoverIcon item-open new-tab" pTooltip="Open in a New Tab"
          tooltipPosition="top"
          tooltipStyleClass="leftTooltip ui-tooltip-text" id="{{item.name}}" (click)="itemSelected($event)">
          <img  alt="Delete" 
          src="assets/Inbox/viewDelete.svg" class="hoverIcon  new-tab item-delete" pTooltip="Delete view"
          tooltipPosition="top"
          tooltipStyleClass="leftTooltip ui-tooltip-text" id="{{item.name}}" (click)="itemSelected($event)">
          <img  alt="Edit" 
          src="assets/Inbox/viewEdit.svg"  class="hoverIcon new-tab item-edit" pTooltip="Edit view"
          tooltipPosition="top"
          tooltipStyleClass="leftTooltip ui-tooltip-text" id="{{item.name}}" (click)="itemSelected($event)">
        </div>

        <div *ngIf="item.count" class="menuChildCount">
          {{item.counts !== undefined? item.counts: item.count}}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="filteredItems.length>3 && !fromMegaMenu" class="shoMoreArrow">
    <div *ngIf="!showMore" (click)="toggleShowMore()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
      >
        <path
          d="M1 1.75L6 6.25L11 1.75"
          stroke="#000F29"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div *ngIf="showMore" (click)="toggleShowMore()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
      >
        <path
          d="M1 6.25L6 1.75L11 6.25"
          stroke="#000F29"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>

  <div #contextMenuContainer id="contextMenuContainer" (click)="onContainerClick($event)" (contextmenu)="onContainerRightClick($event)"   *ngIf="contextmenu==true">
    <app-search-list-contextmenu
      [x]="contextmenuX"
      [y]="contextmenuY"
      [target]="itemId"
    ></app-search-list-contextmenu>
  </div>
</div>
